import { render } from "./HomepageEditor.vue?vue&type=template&id=5c36436c"
import script from "./HomepageEditor.vue?vue&type=script&lang=js"
export * from "./HomepageEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__